"use client"

import { useState } from "react"
import { BookOpen, Calendar, FileText } from "lucide-react"
import type { SubjectData } from "@/lib/class-students-data"

interface SubjectsTabSectionProps {
  subjects: SubjectData[]
}

export function SubjectsTabSection({ subjects }: SubjectsTabSectionProps) {
  const [activeTab, setActiveTab] = useState<"subjects" | "timetable" | "assignments">("subjects")

  return (
    <div className="mt-8">
      {/* Tab Navigation */}
      <div className="border-b border-slate-200 mb-6">
        <nav aria-label="Tabs" className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab("subjects")}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-semibold text-sm flex items-center gap-2 transition-colors ${
              activeTab === "subjects"
                ? "border-teal-600 text-teal-600"
                : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
            }`}
          >
            <BookOpen className="w-5 h-5" />
            Subjects
          </button>
          {/* <button
            onClick={() => setActiveTab("assignments")}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors ${
              activeTab === "assignments"
                ? "border-teal-600 text-teal-600"
                : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
            }`}
          >
            <FileText className="w-5 h-5" />
            Assignments
          </button> */}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === "subjects" && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {subjects.map((subject) => (
            <div
              key={subject.id}
              className="group bg-white rounded-2xl p-5 border border-slate-200 shadow-sm hover:shadow-md hover:border-teal-600/30 transition-all cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <div
                  className={`w-10 h-10 rounded-xl ${subject.iconBg} ${subject.iconColor} flex items-center justify-center`}
                >
                  <span className="material-symbols-outlined">{subject.icon}</span>
                </div>
                <span className="bg-slate-100 text-slate-600 text-[10px] font-bold px-2 py-1 rounded-md uppercase">
                  {subject.category}
                </span>
              </div>
              <h4 className="text-lg font-bold text-slate-800 mb-1 group-hover:text-teal-600 transition-colors">
                {subject.name}
              </h4>
              <p className="text-xs text-slate-500 mb-4">
                {subject.teacher} • {subject.periodsPerWeek} Periods/Week
              </p>
              
            </div>
          ))}
        </div>
      )}

      {activeTab === "timetable" && (
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm">
          <p className="text-slate-500 text-center py-8">Timetable view coming soon</p>
        </div>
      )}

      {activeTab === "assignments" && (
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm">
          <p className="text-slate-500 text-center py-8">Assignments view coming soon</p>
        </div>
      )}
    </div>
  )
}
